import Macy from "macy";
import Cookie from "./Cookie";

export default class ProductReviews {
	constructor() {
		this.jsCommentList = document.querySelector(".jsCommentList");

		this.jsShowAllComments = document.querySelector(".jsShowAllComments");
		this.jsCommentForm = document.querySelector(".comment-form");
		if (this.jsCommentForm) {
			this.jsCommentField = this.jsCommentForm.querySelector("#comment");
			this.jsCommentPrivacyPolicyField = this.jsCommentForm.querySelector("#comment-form-privacy-policy");
		}

		this.events();
	}

	events() {
		if (this.jsCommentList) {
			// eslint-disable-next-line no-unused-vars
			this.macyInstance = Macy({
				container: ".jsCommentList",
				columns: 4,
				margin: {
					x: 24,
					y: 24,
				},

				breakAt: {
					1200: 4,
					980: 3,
					520: 2,
					400: 1,
				},
			});
		}

		if (this.jsCommentForm) {
			this.jsCommentForm.addEventListener("submit", this.validateForm.bind(this));
		}

		if (this.jsShowAllComments) {
			this.jsShowAllComments.addEventListener("click", this.loadAllComments.bind(this));
		}
	}

	loadAllComments(e) {
		const myFormData = new FormData();
		myFormData.append("security", window.global.security);

		const productId = this.jsShowAllComments.dataset.productId;
		myFormData.append("product_id", productId);

		fetch(window.global.ajax_url + "?action=getAllComments", {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: myFormData,
		})
			.then((resp) => resp.json())
			.then((res) => {
				this.jsCommentList.innerHTML = res.data;

				this.macyInstance.reInit();

				this.jsShowAllComments.remove();
			});
	}

	validateForm(event) {
		if (this.jsCommentField.value.trim().length === 0) {
			event.preventDefault();

			const jsCommentFieldWrapper = this.jsCommentField.closest(".comment-form-comment");

			jsCommentFieldWrapper.classList.add("comment-form-comment--invalid");

			const spanError = document.createElement("span");
			spanError.classList.add("comment-form-error");
			spanError.appendChild(document.createTextNode(this.jsCommentField.dataset.error));

			jsCommentFieldWrapper.appendChild(spanError);
		}

		if (this.jsCommentPrivacyPolicyField.checked === false) {
			event.preventDefault();

			const jsCommentPrivacyPolicyFieldWrapper =
				this.jsCommentPrivacyPolicyField.closest(".comment-form-privacy-policy");

			jsCommentPrivacyPolicyFieldWrapper.classList.add("comment-form-privacy-policy--invalid");

			const spanError = document.createElement("span");
			spanError.classList.add("comment-form-error");
			spanError.appendChild(document.createTextNode(this.jsCommentPrivacyPolicyField.dataset.error));

			jsCommentPrivacyPolicyFieldWrapper.appendChild(spanError);
		}
	}
}
